module.exports = __webpack_public_path__ + "img/30.dd8719d4.png";